import React from 'react';
import {Modal, notification} from 'antd';
import {createCsv} from './exportModalUtils';
import {DOWNLOAD_STEP} from './exportModalConst';
import {GET_PAYMENTS} from '../../graphql';
import {client} from '../../../../api/graphql';

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  regionId: string;
  filter: string;
}

interface State {
  modalBodyText: string;
  confirmLoading: boolean;
}

const defaultState = {
  modalBodyText: DOWNLOAD_STEP.STEP_ONE,
  confirmLoading: false
};

class ExportModal extends React.PureComponent<Props, State> {
  state = defaultState;
  linkRef = React.createRef<HTMLAnchorElement>();

  handleConfimModal = () => {
    this.setState({confirmLoading: true, modalBodyText: DOWNLOAD_STEP.STEP_TWO}, this.exportCsv);
  };

  resetState = () => this.setState(defaultState);

  exportCsv = () => {
    const {regionId, filter, onCancel} = this.props;

    client
      .query({
        query: GET_PAYMENTS,
        variables: {
          regionId,
          filter
        }
      })
      .then(({data}: any) => {
        this.setState({modalBodyText: DOWNLOAD_STEP.STEP_THREE}, () => {
          createCsv(data.payments.payments, this.linkRef.current);
          this.resetState();
          onCancel();
        });
      })
      .catch((err: any) => {
        notification.error({
          message: 'Error while loading submissions for export...',
          description: 'Please, try it again.'
        });
        console.error('Submissions error:', err);
        this.resetState();
      });
  };

  render() {
    const {isOpen, onCancel} = this.props;
    const {confirmLoading, modalBodyText} = this.state;

    return (
      <Modal
        title="Export CSV"
        visible={isOpen}
        destroyOnClose={true}
        confirmLoading={confirmLoading}
        onCancel={onCancel}
        onOk={this.handleConfimModal}
      >
        {modalBodyText}
        <a ref={this.linkRef} style={{display: 'none'}} />
      </Modal>
    );
  }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/components/ExportModal/ExportModal.tsx